import { t } from "@impero-com/common/utils/i18n";
import { PieChart, ChartData } from "@impero-com/ui";
import { rawPalette } from "@impero-com/ui/styles/theme.css";

import { ExistingControlActivityStatus } from "utils/controlResults/activityStatusUtils";

export interface ActivityNumbers {
    completed: number;
    completedAfterDue: number;
    overdue: number;
    toBeSent: number;
    pending: number;
}

interface ActivityPieChartProps {
    numbers: ActivityNumbers;
    getActivitiesByStatusUrl: (
        statusKey: ExistingControlActivityStatus | null
    ) => string;
}

export function ActivityPieChart({
    numbers,
    getActivitiesByStatusUrl,
}: ActivityPieChartProps) {
    const data: Array<ChartData<ExistingControlActivityStatus>> = [
        {
            label: t("Report_Status_Completed"),
            value: numbers.completed,
            color: rawPalette.base.green[600],
            statusKey: "Completed",
        },
        {
            label: t("Report_Status_WorkflowStatus_CompletedAfterDue"),
            value: numbers.completedAfterDue,
            color: rawPalette.base.green[200],
            statusKey: "CompletedAfterDueDate",
        },
        {
            label: t("Report_Status_Overdue"),
            value: numbers.overdue,
            color: rawPalette.base.red[500],
            statusKey: "Overdue",
        },
        {
            label: t("Report_Status_Pending"),
            value: numbers.pending,
            color: rawPalette.base.orange[500],
            statusKey: "Pending",
        },
        {
            label: t("Report_Status_WorkflowStatus_Future"),
            value: numbers.toBeSent,
            color: rawPalette.base.lightBlue[500],
            statusKey: null, // We dont want to pass the future activities to the url for the activities view
        },
    ];

    return (
        <PieChart
            showLegend
            tooltip
            data={data}
            getActivitiesByStatusUrl={getActivitiesByStatusUrl}
        />
    );
}
